import { Deserializable } from '../deserializable';

export class SarsConfig implements Deserializable {

    public sda: number;
    public fia: number;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
